import { FC } from 'react'

import styled from 'styled-components'

import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import { CreateAdCampaignResponse } from 'src/Redux/ad-campaignApi'

import { AdsScheduleGenres } from '../AdsScheduleGenres'
import { AdsScheduleArtists } from '../AdsScheduleArtists'
import { AdsScheduleLanguages } from '../AdsScheduleLanguages'

const Container = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  background: ${({ theme }) => theme.color.white};
  box-shadow: ${({ theme }) => theme.shadow.card};

  @media screen and (max-width: ${MAX_MOBILE_WIDTH}) {
    width: 100%;
  }
`

const Title = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
`

interface AdsTrackParametersProps {
  adCampaignData?: CreateAdCampaignResponse
}

export const AdsTrackParameters: FC<AdsTrackParametersProps> = ({
  adCampaignData,
}) => {
  const genres = adCampaignData?.genres || []
  const languages = adCampaignData?.languages || []
  const artists = adCampaignData?.similarArtistNames || []

  return (
    <Container>
      <Title>Targeting</Title>
      <AdsScheduleGenres genres={genres} />
      <AdsScheduleLanguages
        languages={languages}
        strategy={adCampaignData?.strategy}
      />
      {adCampaignData?.strategy === 'track' && (
        <AdsScheduleArtists artists={artists} />
      )}
    </Container>
  )
}
